import { apiSlice } from "../../app/api/apiSlice";

export const registerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (data) => ({
        url: "/register",
        method: "POST",
        body: { ...data },
      }),
    }),
    initialize: builder.mutation({
      query: (data) => ({
        url: "/initialize",
        method: "POST",
        body: { ...data },
      }),
    }),
  }),
});

export const { useRegisterMutation, useInitializeMutation } = registerApiSlice;
